exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_title[data-v-25e22a60] {\n  color: #235AA3;\n  font-size: 24px;\n  line-height: 35px;\n  font-weight: bold;\n  text-align: center;\n}\n.btn_area[data-v-25e22a60] {\n  margin-top: 18px;\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n}\n@media (max-width: 768px) {\n.btn_area[data-v-25e22a60] {\n    margin-top: 21px;\n}\n}\n.hidden[data-v-25e22a60] {\n  display: none;\n}\n#unfilled[data-v-25e22a60] {\n  text-align: center;\n  padding: 120px 30px;\n}", ""]);

// exports
